<template>
    <div class="row panel-body">
        <form method="post" ref="form">
            <input type="hidden" name="_token" :value="csrfToken"/>

            <div class="row">
                <div class="col-xs-offset-1 col-xs-11">
                    <div class="row">
                        <div class="col-xs-3">
                            <h4>English Master</h4>
                        </div>

                        <div class="col-xs-5">
                          <h4>{{translationLanguage}} Translation</h4>
                        </div>

                        <div class="col-xs-4" v-if="finishedLanguages">
                            <h4 v-for="(language) in finishedLanguages" class="hideable-by-language" :data-language-id="language.id">{{language.title}} Master</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row subtitle-proofread-cue">
                <div class="col-xs-1" style="white-space: nowrap; line-height: 2em;">
                    Title
                </div>
                <div class="col-xs-11">
                    <div class="row">
                        <div class="col-xs-3 ">
                            <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" v-html="masterTitle"></p>
                        </div>

                        <div class="col-xs-5">
                            <i
                                    style="margin-left: 5px;"
                                    class="fa fa-eye tool_tip"
                                    :title="translatedTitle"
                                    data-toggle="tooltip">

                            </i>
                            <input
                                    type="text"
                                    :value="translatedTitle"
                                    name="lesson_title"
                                    :required="'required'"
                                    />
                        </div>

                        <div class="col-xs-4" v-if="finishedLanguages">
                          <p v-for="(language) in finishedLanguages" class="hideable-by-language" :data-language-id="language.id" dir="auto" style="padding-bottom: 5px; line-height: 2em;"
                             v-html="finishedLanguageTitles[language.id] === '' ? 'not yet translated...' : finishedLanguageTitles[language.id]"></p>
                        </div>
                    </div>
                </div>
            </div>

            <subtitle-proofread-cue
                    v-for="(cue, number) in masterCues"
                    :number="number"
                    :key="number"
                    :showFinishedLanguages="!!finishedLanguageCues"
                    :masterLines="cue"
                    :translatedLines="translatedCues[number]"
                    :finishedLanguageLines="finishedLanguageCues ? finishedLanguageCues[number] : ''"
                    :wipLines="wipCues[number]"
                    :isApproved="isApproved(number)"
                    :isRejected="isRejected(number)">
            </subtitle-proofread-cue>

            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-default"
                            name="submit-save"
                            @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                </div>

                <div class="col-xs-6 text-right">
                    <submit-button></submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        props: [
            'masterCuesJson',
            'finishedLanguageCuesJson',
            'finishedLanguagesJson',
            'finishedLanguageTitlesJson',
            'translatedCuesJson',
            'workInProgressJson',
            'saveRoute',
            'translationLanguage',
            'masterTitle',
            'translatedTitle'
        ],

        data: function () {
            return {
                csrfToken: window.csrfToken,
                showWarningMessage: true,
                autosaveCache: '',
            }
        },

        computed: {
            masterCues: function () {
                return JSON.parse(this.masterCuesJson);
            },
            finishedLanguageCues: function () {
                return JSON.parse(this.finishedLanguageCuesJson);
            },
            finishedLanguages: function () {
                return JSON.parse(this.finishedLanguagesJson);
            },
            finishedLanguageTitles: function () {
                return JSON.parse(this.finishedLanguageTitlesJson);
            },
            translatedCues: function () {
                return JSON.parse(this.translatedCuesJson);
            },
            wipCues: function () {
                return JSON.parse(this.workInProgressJson).edits;
            },
            approved: function () {
                return JSON.parse(this.workInProgressJson).approved;
            },
            rejected: function () {
                return JSON.parse(this.workInProgressJson).rejected;
            },
            rejectionComment: function () {
                return JSON.parse(this.workInProgressJson).rejectionComment;
            }
        },

        mounted() {
            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer();
        },

        methods: {
            isApproved(number) {
                return this.approved.indexOf(number.toString()) > -1;
            },

            isRejected(number) {
                return this.rejected.indexOf(number.toString()) > -1;
            },
            autosaveTimer() {
                setTimeout(() => {
                    this.autosave();
                    this.autosaveTimer();
                }, 60000); // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(from) {
                let formData = $(this.$refs.form).serialize();

                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(from);
                }).catch(() => {
                    toastr.error('Something went wrong...', from);
                });
            }
        }
    }
</script>
